import VueWrapper from '@/components/core/Vue/vue.wrapper';
import ClientFooterComponent from '@/components/vuetify/client-footer/client-footer.component';
import {PaymentApiService} from '@/sdk/api-services/payment.api';
import {Component} from 'vue-property-decorator';

@Component({
    components: {
        ClientFooterComponent,
    },
})
export default class PaymentSuccessComponent extends VueWrapper {
    paymentKey: string = '';
    orderId: string = '';
    amount: number = 0;
    planId: string = '';

    public paymentSrv = new PaymentApiService();
    public isLoading = true;
    public isSuccess = false;
    public errorMessage = '';

    created() {
        const query = this.$route.query;
        this.paymentKey = (query.paymentKey as string) || '';
        this.orderId = (query.orderId as string) || '';
        this.amount = Math.round(Number(query.amount) || 0);
        this.planId = (query.planId as string) || '';
    }

    async mounted() {
        if (this.planId && this.paymentKey && this.orderId && this.amount) {
            await this.confirmPayment();
        } else {
            this.isLoading = false;
            this.errorMessage = (this.$t('PaymentPage.PaymentSuccess.invalidData') as string) || 'Invalid payment data.';
        }
    }

    async confirmPayment() {
        try {
            await this.paymentSrv.confirmPayment(this.planId, this.paymentKey, this.orderId, this.amount);
            const paymentStatus = await this.paymentSrv.getCurrentUserPaymentStatus();
            this.UserSessionSrv.paymentStatus$.next(paymentStatus);
            this.UserSessionSrv.paymentStatusLoaded$.next(true);
            this.isSuccess = true;
        } catch (e: any) {
            console.error('Payment confirmation failed:', e);

            const backendMsg = e.response?.data?.error?.message || e.response?.data?.message || e.error.message;
            this.errorMessage = backendMsg || e.message || 'Payment confirmation failed.';
        } finally {
            this.isLoading = false;
        }
    }

    formatKrw(value: number): string {
        return new Intl.NumberFormat('ko-KR', {style: 'currency', currency: 'KRW'}).format(value);
    }

    goBack() {
        this.$router.push({name: 'SubscriptionPlan'});
    }
}
